<template>
  <!-- Impossible de passer le context vuetify au toaster obliger de passer par les balises font-awesome -->
  <FaIcon class="text-successText" :icon="['fas', 'circle-check']" />
</template>
